import {Offer} from '@findhotel/sapi'

/**
 * Sort offers by price
 * @param offers - Array of offers to sort by price
 * @returns Array of offers sorted by base rate in ascending order
 */
export const sortOffersByPrice = <T extends Pick<Offer, 'rate'>>(
  offers: T[]
) => {
  return [...offers].sort((a, b) => a.rate.base - b.rate.base)
}
